import React from "react";
import 'quill/dist/quill.snow.css'
import ReactQuill from 'react-quill'

interface EditorProps {
    onChange: (value: string) => void;
    value: string;
    className?: string;
    label?: string;
    disabled?: boolean;
}

export const TextEditor = ( props: EditorProps ) => {
    const editorModules = {
        toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
                { align: [] }
            ],
            [{ "color": ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", 'custom-color'] }],
        ]
    };

    const formats = [
        "header", "height", "bold", "italic",
        "underline", "strike", "blockquote",
        "list", "color", "bullet", "indent",
        "align", "size",
    ];

    return (
        <div className='editor-container'>
            <div className='row text-start'>
                <label>{ props.label? props.label : '' }</label>
            </div>
            <div className='row mt-2'>
                <ReactQuill
                    theme="snow"
                    modules={ editorModules}
                    formats={ formats}
                    placeholder="..."
                    onChange={ (value) => {
                        if (!props.disabled) {
                            props.onChange(value)
                        }
                    } }
                    value={ props.value }
                    readOnly={props.disabled}
                    className={ props.className? `${props.className} standard-text-editor` : 'standard-text-editor' }
                />
            </div>
        </div>
    );
}

